import _axios from 'axios'
import config from '../../config'
import { getUserToken } from '../../contexts/Auth'
import {
  EssentialVehicleMaster,
  MasterVehicleBrand,
  MasterVehicleColor,
  MasterVehicleEngineType,
  MasterVehicleFuelType,
  MasterVehicleModel,
  MasterVehicleSize,
  MasterVehicleSizeIntl,
  MasterVehicleType,
} from './vehicle.interfaces'

const { restful } = config
const axios = _axios.create({
  baseURL: `${restful.URL}`,
})
// Read the token per request: it can change after module load (e.g. LINE login without a page reload)
axios.interceptors.request.use((req) => {
  const accessToken = getUserToken()
  if (accessToken) {
    req.headers = { ...req.headers, Authorization: accessToken }
  }
  return req
})

export async function getEssentialVehicleMaster() {
  return (
    await axios.get<{ result: boolean; data: EssentialVehicleMaster }>(
      `/cms/vehicle/essential/master`,
    )
  ).data
}

export async function getVehicleBrands() {
  return (await axios.get<MasterVehicleBrand[]>(`/master/vehicle/brand`)).data
}

export async function getVehicleModels(brand: string) {
  return (await axios.get<MasterVehicleModel[]>(`/master/vehicle/model`, { params: { brand } }))
    .data
}

export async function getVehicleColors() {
  return (await axios.get<MasterVehicleColor[]>(`/master/vehicle/color`)).data
}

export async function getVehicleTypes() {
  return (await axios.get<MasterVehicleType[]>(`/master/vehicle/type`)).data
}

export async function getVehicleSizes() {
  return (await axios.get<MasterVehicleSize[]>(`/master/vehicle/size`)).data
}

export async function getVehicleSizeIntls() {
  return (await axios.get<MasterVehicleSizeIntl[]>(`/master/vehicle/sizeintl`)).data
}

export async function getVehicleEngineTypes() {
  return (await axios.get<MasterVehicleEngineType[]>(`/master/vehicle/enginetype`)).data
}

export async function getVehicleFuelTypes() {
  return (await axios.get<MasterVehicleFuelType[]>(`/master/vehicle/fueltype`)).data
}
